export class PriceErrorConstants {
  public static EMPTY_PRICE_ERROR = "Price cannot be empty";
  public static ZERO_PRICE_ERROR = "Price cannot be 0";
  public static INVALID_PRICE_ERROR = "Invalid Price";
  public static ZERO_AND_CABINET_ERROR =
    "Price cannot be 0. Tick up to access cabinet prices, if available";
  public static TICK_UP_TO_CABINET_PRICES_ERROR =
    "Tick to access cabinet prices, if available";
  public static TICK_SIZE = "Tick Size: ";
}
